import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

function StickyRequestBanner({
  isValid, resourceId, handleShowModal, consultantName,
}) {
  return (
    <Fragment>
      <div className={`sticky-request-edit-banner d-none d-sm-block ${isValid ? '' : 'not-valid'}`}>
        <div className="container g-row g-row--between">
          <div>
            {
            isValid ? (
              <div className="sticky-message">
                <strong>Requesting edits: </strong>
                Tell
                {' '}
                <strong>{consultantName}</strong>
                {' '}
                general and/or
                specific changes that must be addressed.
              </div>
            ) : (
              <div className="sticky-message">
                <i className="fa fa-exclamation-triangle" />
                <strong>Requesting edits: </strong>
                Add at least 1 comment to be able to send and request edits.
              </div>
            )
          }
          </div>
          <div className="sticky-request-edit-banner-actions g-row">
            <a className="invoice-cancel-request-edit btn btn-alt border-white text-white me-3" href={`/invoices/${resourceId}`}>Cancel</a>
            <button type="button" className="btn btn-alt-secondary bg-white" onClick={() => handleShowModal()}>
              Send Edits
            </button>
          </div>
        </div>
      </div>
      <div className={`sticky-request-edit-banner mobile-sticky ${isValid ? '' : 'not-valid'}`}>
        <div className="container g-row g-row--between">
          <div>
            {
            isValid ? (
              <div className="sticky-message">
                <i className="fas fa-edit" />
                <strong>Requesting edits:</strong>
                {' '}
                Add comments first.
              </div>
            ) : (
              (
                <div className="sticky-message">
                  <i className="fa fa-exclamation-triangle" />
                  <strong>Requesting edits:</strong>
                  Add at least 1 comment to be able to send and request edits.
                </div>
              )
            )
          }
          </div>
          <div className="sticky-request-edit-banner-actions">
            <a className="invoice-cancel-request-edit btn btn-alt border-white text-white me-3" href={`/invoices/${resourceId}`}>Cancel</a>
            <button type="button" className="btn btn-alt-secondary bg-white" onClick={() => handleShowModal()}>
              Send Edits
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

StickyRequestBanner.propTypes = {
  isValid: PropTypes.bool.isRequired,
  resourceId: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  handleShowModal: PropTypes.func.isRequired,
};

export default StickyRequestBanner;
